import { OrderDetails } from "../shared/types/dashboard";

/**
 * Calculates total received amounts grouped by payment method.
 * Example output:
 * {
 *   "Cash": 500,
 *   "Card": 1200,
 *   "UPI": 800
 * }
 */
export const calculatePaymentMethods = (orders: OrderDetails[]) => {
  const paymentMap: Record<string, number> = {};

  orders.forEach((order) => {
    order.payments?.forEach((payment) => {
      const method = payment.Paymentmethod || "Unknown";
      const received = Number(payment.ReceivedAmount) || 0;

      // Sum up received amounts per payment type
      paymentMap[method] = (paymentMap[method] || 0) + received;
    });
  });

  return paymentMap;
};
